/**
 * Компонент отображения версии приложения
 * Показывается внизу экрана полупрозрачным текстом
 */
import './AppVersion.css'

const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0'

export const AppVersion = () => {
  return (
    <div className="app-version">
      v{APP_VERSION}
    </div>
  )
}









